import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { adminApi } from "@/lib/adminAuth";
import { toast } from "sonner";
import { CheckCircle2, XCircle, Send } from "lucide-react";

export default function AdminWithdrawals() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("pending");
  const [notes, setNotes] = useState({});

  const load = () => {
    const params = tab && tab !== "all" ? `?status=${tab}` : "";
    api.get(`/admin/withdrawals${params}`, adminApi()).then(({ data }) => setItems(data));
  };
  useEffect(() => { load(); }, [tab]);  // eslint-disable-line

  const approve = async (id) => { try { await api.post(`/admin/withdrawals/${id}/approve`, {}, adminApi()); toast.success("Onaylandı"); load(); } catch (e) { toast.error(e.response?.data?.detail || "Hata"); } };
  const markPaid = async (id) => { if (!window.confirm("Ödeme yapıldı olarak işaretlemek istiyor musun?")) return; try { await api.post(`/admin/withdrawals/${id}/mark-paid`, {}, adminApi()); toast.success("Ödendi"); load(); } catch (e) { toast.error(e.response?.data?.detail || "Hata"); } };
  const reject = async (id) => { try { await api.post(`/admin/withdrawals/${id}/reject`, { notes: notes[id] || "" }, adminApi()); toast.success("Reddedildi ve bakiye iade edildi"); load(); } catch (e) { toast.error(e.response?.data?.detail || "Hata"); } };

  return (
    <div className="font-admin-body" data-testid="admin-withdrawals">
      <h1 className="font-admin-head text-3xl mb-4">Çekim Talepleri</h1>
      <div className="flex gap-2 mb-4 flex-wrap">
        {[["pending","Bekleyen"],["approved","Onaylı"],["paid","Ödenmiş"],["rejected","Red"],["all","Tümü"]].map(([k,l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`wd-tab-${k}`} className={`px-3 py-1.5 rounded-full text-sm ${tab === k ? "bg-[#F59E0B]/20 text-[#F59E0B]" : "bg-white/5 text-white/60"}`}>{l}</button>
        ))}
      </div>

      <div className="admin-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-white/50 uppercase tracking-wider">
            <tr className="border-b border-[#27272A]">
              <th className="p-3">Tarih</th><th className="p-3">Falcı ID</th><th className="p-3">Tutar</th><th className="p-3">IBAN</th><th className="p-3">Hesap</th><th className="p-3">Durum</th><th className="p-3">Eylem</th>
            </tr>
          </thead>
          <tbody>
            {items.map((w) => (
              <tr key={w.id} className="border-b border-[#18181B]" data-testid={`wd-${w.id}`}>
                <td className="p-3 text-xs text-white/60">{new Date(w.created_at).toLocaleString("tr-TR")}</td>
                <td className="p-3 text-xs font-mono">{w.falci_id.slice(0, 8)}</td>
                <td className="p-3 tabular-nums text-[#F59E0B]">{w.amount_try} ₺</td>
                <td className="p-3 text-xs font-mono">{w.iban}</td>
                <td className="p-3 text-xs">{w.account_holder}<br /><span className="text-white/40">{w.bank_name}</span></td>
                <td className="p-3"><span className={`text-xs px-2 py-0.5 rounded ${w.status === "paid" ? "bg-emerald-500/20 text-emerald-300" : w.status === "rejected" ? "bg-red-500/20 text-red-300" : w.status === "approved" ? "bg-blue-500/20 text-blue-300" : "bg-amber-500/20 text-amber-300"}`}>{w.status}</span></td>
                <td className="p-3">
                  {w.status === "pending" && (
                    <div className="flex gap-1 items-center">
                      <button onClick={() => approve(w.id)} data-testid={`wd-approve-${w.id}`} className="admin-btn-ghost text-xs px-2 py-1 text-emerald-400"><CheckCircle2 className="w-3.5 h-3.5" /></button>
                      <input value={notes[w.id] || ""} onChange={(e) => setNotes({ ...notes, [w.id]: e.target.value })} placeholder="Red nedeni" className="admin-input text-xs h-7 w-24" />
                      <button onClick={() => reject(w.id)} data-testid={`wd-reject-${w.id}`} className="admin-btn-ghost text-xs px-2 py-1 text-red-400"><XCircle className="w-3.5 h-3.5" /></button>
                    </div>
                  )}
                  {w.status === "approved" && (
                    <button onClick={() => markPaid(w.id)} data-testid={`wd-paid-${w.id}`} className="admin-btn text-xs px-2 py-1 flex items-center gap-1"><Send className="w-3.5 h-3.5" /> Ödendi</button>
                  )}
                  {(w.status === "paid" || w.status === "rejected") && <span className="text-xs text-white/40">-</span>}
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={7} className="p-10 text-center text-white/40">Bu sekmede talep yok.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
